export default __webpack_public_path__ + "static/media/corghi2.e0c4d601.png";